module.exports = __webpack_public_path__ + "img/design_education.d5be1fe3.jpg";